// src/PlayerCollage.js
import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";

const CollageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const TeamHeading = styled.h2`
  margin: 20px 0;
  text-align: center;
`;

const PlayerGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  justify-content: center;
`;

const PlayerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 30%;
  min-width: 150px;
  max-width: 200px;
  
  @media (max-width: 768px) {
    width: 45%;
    min-width: 120px;
  }
`;

const PlayerImage = styled.img`
  width: 100%;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center top;
  border: 3px solid #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  aspect-ratio: 1;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (min-width: 600px) {
    height: 200px;
  }

  @media (min-width: 900px) {
    height: 220px;
  }
`;

const PlayerName = styled.p`
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  @media (min-width: 600px) {
    font-size: 16px;
  }

  @media (min-width: 900px) {
    font-size: 18px;
  }
`;

const PlayerCollage = ({ seriesName, teamName, players ,teamLogo,auctionLink,leagueLogo,ourLogo, onPlayerClick}) => {
  return (
    <CollageContainer>
      <TeamHeading>
      <Link to={auctionLink}>{seriesName}</Link>
        <br></br>{teamName}



        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
  {/*
  {leagueLogo ? (
    <img
      src={leagueLogo}
      alt="League Logo"
      style={{ maxHeight: '200px', marginRight: '20px' }}
    />
  ) : null}
  */}
  
{teamLogo && (
          <>
            <br />
            <img src={teamLogo} alt={`${teamName} logo`} style={{ marginTop: '10px', maxHeight: '200px' ,maxWidth:'200px' }} />
          </>
        )}

   <img src={ourLogo} width="100px" alt="Logo 1" />


  </div>


      
        </TeamHeading>
      <PlayerGrid>
        {players.map((player) => (
          <PlayerCard key={player.sl_no}>
            <PlayerImage 
              src={player.profile_pic} 
              alt={player.full_name}
              onClick={() => onPlayerClick && onPlayerClick(player)}
            />
            <PlayerName 
              onClick={() => onPlayerClick && onPlayerClick(player)}
            >
              {player.full_name}
            </PlayerName>
          </PlayerCard>
        ))}
      </PlayerGrid>
    </CollageContainer>
  );
};

export default PlayerCollage;
